import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const ITEMS = [
  "AIR & OCEAN FREIGHT",
  "CUSTOMS CLEARANCE",
  "DOOR-TO-DOOR DELIVERY",
  "SHIP WITH EASE",
  "FREE US MAILBOX",
];

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="border-y border-white/10 py-5 bg-[#1C0D2C]/40 overflow-hidden"
  >
    <Marquee speed={35} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-display font-800 tracking-tight text-2xl sm:text-3xl text-[#F8F7FA]/90 px-6">
            {item}
          </span>
          <Asterisk className="w-6 h-6 text-[#FF8A00]" />
        </span>
      ))}
    </Marquee>
  </div>
);
